import { adminUsersConstants } from '../Constants';
import { adminUsersServices } from '../Services';
import {editadminUsersConstans} from "../Constants"

export const adminUsersActions = {
    searchAgents,
    EDITAgent
};

function searchAgents(data: any) {
    return (dispatch:any) => {
        dispatch(dispatchFunction({
            type: adminUsersConstants.SEARCH_AGENT_REQUEST,
            data: null
        }));
        adminUsersServices.searchAgent(data)
            .then(
                response => {
                    if (response.status) {
                        dispatch(dispatchFunction({
                            type: adminUsersConstants.SEARCH_AGENT_SUCCESS,
                            data: response.data
                        }));
                    } else {
                        dispatch(dispatchFunction({
                            type: adminUsersConstants.SEARCH_AGENT_FAILURE,
                            data: response
                        }));
                    }
                },
                error => {
                    dispatch(dispatchFunction({
                        type: adminUsersConstants.SEARCH_AGENT_FAILURE,
                        data: error.message
                    }));
                }
            );
    };
}

function EDITAgent(data:any) {
    return (dispatch:any) => {
        dispatch(dispatchFunction({
            type: editadminUsersConstans.EDIT_AGENT_REQUEST,
            data: null
        }));
        adminUsersServices.editAgent(data)
            .then(
                response => {
                    if (response.status) {
                        dispatch(dispatchFunction({
                            type: editadminUsersConstans.EDIT_AGENT_SUCCESS,
                            data: response.data
                        }));
                    } else {
                        dispatch(dispatchFunction({
                            type: editadminUsersConstans.EDIT_AGENT_FAILURE,
                            data: response
                        }));
                    }
                },
                error => {
                    dispatch(dispatchFunction({
                        type: editadminUsersConstans.EDIT_AGENT_FAILURE,
                        data: error.message
                    }));
                }
            );
    };
}


function dispatchFunction(data: any) {
    // To do: check for refresh / unauthorized error
    return {
        type: data.type,
        data: data.data
    };
}